import { render } from "./ArticleView.vue?vue&type=template&id=b7b09506&scoped=true"
import script from "./ArticleView.vue?vue&type=script&lang=js"
export * from "./ArticleView.vue?vue&type=script&lang=js"

import "./ArticleView.vue?vue&type=style&index=0&id=b7b09506&lang=css"
import "./ArticleView.vue?vue&type=style&index=1&id=b7b09506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b09506"]])

export default __exports__